import { useState, useEffect } from 'react';
import api, { storageBaseUrl } from '../../api';

const PREFECTURES = [
    '北海道','青森県','岩手県','宮城県','秋田県','山形県','福島県',
    '茨城県','栃木県','群馬県','埼玉県','千葉県','東京都','神奈川県',
    '新潟県','富山県','石川県','福井県','山梨県','長野県','岐阜県',
    '静岡県','愛知県','三重県','滋賀県','京都府','大阪府','兵庫県',
    '奈良県','和歌山県','鳥取県','島根県','岡山県','広島県','山口県',
    '徳島県','香川県','愛媛県','高知県','福岡県','佐賀県','長崎県',
    '熊本県','大分県','宮崎県','鹿児島県','沖縄県',
];

const textInputStyle = {
    width: '100%',
    padding: '11px 14px',
    border: '1px solid #e0e4ea',
    borderRadius: 6,
    fontSize: '0.9rem',
    color: '#1a1a2e',
    background: '#fff',
    outline: 'none',
    boxSizing: 'border-box',
};

const labelStyle = { fontSize: '0.78rem', color: '#6b7280', display: 'block', marginBottom: 4 };

const fmtDate = (val) => {
    if (!val) return '—';
    try { return new Date(val).toLocaleDateString('ja-JP', { year: 'numeric', month: '2-digit', day: '2-digit' }); }
    catch { return '—'; }
};

const ConditionCard = ({ condition: c, onSaved }) => {
    const [editingAddress, setEditingAddress] = useState(false);
    const [savingAddress, setSavingAddress] = useState(false);
    const [addressError, setAddressError] = useState(null);
    const [sitePostalCode, setSitePostalCode] = useState('');
    const [sitePrefecture, setSitePrefecture] = useState('');
    const [siteCity, setSiteCity] = useState('');
    const [siteStreet, setSiteStreet] = useState('');
    const [siteBuildingInput, setSiteBuildingInput] = useState('');

    if (!c) return null;

    const siteAddressDisplay = [c.location_prefecture, c.location_city, c.site_address, c.site_building].filter(Boolean).join(' ');
    const fields = [
        { label: '工事の幅員', value: c.construction_width },
        { label: '希望工期', value: c.desired_period },
        { label: '工事動機', value: c.construction_motive },
        { label: 'お客様の種別', value: c.customer_type },
    ].filter(f => f.value);

    const startEditAddress = () => {
        setSitePostalCode(c.site_postal_code || '');
        setSitePrefecture(c.location_prefecture || '');
        setSiteCity(c.location_city || '');
        setSiteStreet(c.site_address || '');
        setSiteBuildingInput(c.site_building || '');
        setAddressError(null);
        setEditingAddress(true);
    };

    const fillSiteAddressFromPostal = async () => {
        const clean = sitePostalCode.replace(/-/g, '');
        if (clean.length !== 7) { setAddressError('郵便番号は7桁で入力してください。'); return; }
        try {
            const res = await fetch(`https://zipcloud.ibsnet.co.jp/api/search?zipcode=${clean}`);
            const data = await res.json();
            if (data.results) {
                const r = data.results[0];
                setSitePrefecture(r.address1); setSiteCity(r.address2 + r.address3); setAddressError(null);
            } else { setAddressError('該当する住所が見つかりませんでした。'); }
        } catch { setAddressError('住所の取得に失敗しました。'); }
    };

    const saveAddress = async () => {
        setSavingAddress(true); setAddressError(null);
        try {
            const res = await api.put(`conditions/${c.id}`, {
                site_postal_code: sitePostalCode.replace(/-/g, ''),
                location_prefecture: sitePrefecture,
                location_city: siteCity,
                site_address: siteStreet,
                site_building: siteBuildingInput,
            });
            onSaved(res.data);
            setEditingAddress(false);
        } catch {
            setAddressError('保存に失敗しました。');
        } finally {
            setSavingAddress(false);
        }
    };

    return (
        <div>
            {c.work_types?.length > 0 && (
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 10 }}>
                    {c.work_types.map((t, i) => (
                        <span key={i} style={{ padding: '3px 10px', background: '#e6f2f1', color: '#005c53', borderRadius: 20, fontSize: '0.78rem', fontWeight: 500 }}>
                            {t}
                        </span>
                    ))}
                </div>
            )}

            {/* 工事先住所（編集可） */}
            <div style={{ marginBottom: 10 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 8, marginBottom: editingAddress ? 8 : 0 }}>
                    <div style={{ display: 'flex', gap: 12, fontSize: '0.84rem', flex: 1 }}>
                        <span style={{ color: '#6b7280', minWidth: 90, flexShrink: 0 }}>工事先住所</span>
                        {!editingAddress && (
                            <span style={{ color: siteAddressDisplay ? '#1a1a2e' : '#9ca3af' }}>
                                {siteAddressDisplay || '未定'}
                            </span>
                        )}
                    </div>
                    {!editingAddress && (
                        <button type="button" onClick={startEditAddress} style={{
                            background: 'none', border: 'none', color: '#005c53', fontSize: '0.8rem', fontWeight: 600, cursor: 'pointer', padding: 0, whiteSpace: 'nowrap',
                        }}>
                            {siteAddressDisplay ? '編集' : '入力する'}
                        </button>
                    )}
                </div>

                {editingAddress && (
                    <div style={{ background: '#f5f6f8', borderRadius: 8, padding: 14 }}>
                        <div style={{ display: 'flex', gap: 8, alignItems: 'flex-end', marginBottom: 8 }}>
                            <div style={{ flex: 1 }}>
                                <label style={labelStyle}>郵便番号</label>
                                <input value={sitePostalCode} onChange={e => setSitePostalCode(e.target.value)} placeholder="1234567（ハイフンなし）" maxLength={8} style={textInputStyle} />
                            </div>
                            <button type="button" onClick={fillSiteAddressFromPostal} style={{
                                padding: '11px 14px', background: '#141c3d', color: '#fff',
                                border: 'none', borderRadius: 6, fontSize: '0.82rem', fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap',
                            }}>
                                住所自動入力
                            </button>
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 8 }}>
                            <div>
                                <label style={labelStyle}>都道府県</label>
                                <select value={sitePrefecture} onChange={e => setSitePrefecture(e.target.value)} style={textInputStyle}>
                                    <option value="">都道府県を選択</option>
                                    {PREFECTURES.map(p => <option key={p}>{p}</option>)}
                                </select>
                            </div>
                            <div>
                                <label style={labelStyle}>市区町村</label>
                                <input value={siteCity} onChange={e => setSiteCity(e.target.value)} style={textInputStyle} />
                            </div>
                        </div>
                        <div style={{ marginBottom: 8 }}>
                            <label style={labelStyle}>番地</label>
                            <input value={siteStreet} onChange={e => setSiteStreet(e.target.value)} style={textInputStyle} />
                        </div>
                        <div style={{ marginBottom: 10 }}>
                            <label style={labelStyle}>建物名</label>
                            <input value={siteBuildingInput} onChange={e => setSiteBuildingInput(e.target.value)} style={textInputStyle} />
                        </div>

                        {addressError && <p style={{ color: '#e53935', fontSize: '0.8rem', margin: '0 0 8px' }}>{addressError}</p>}

                        <div style={{ display: 'flex', gap: 8 }}>
                            <button type="button" onClick={() => setEditingAddress(false)} style={{
                                flex: 1, padding: '10px', background: '#fff', color: '#1a1a2e',
                                border: '1px solid #e0e4ea', borderRadius: 6, fontSize: '0.84rem', fontWeight: 500, cursor: 'pointer',
                            }}>
                                キャンセル
                            </button>
                            <button type="button" onClick={saveAddress} disabled={savingAddress} style={{
                                flex: 1, padding: '10px', background: '#005c53', color: '#fff',
                                border: 'none', borderRadius: 6, fontSize: '0.84rem', fontWeight: 600,
                                cursor: savingAddress ? 'default' : 'pointer', opacity: savingAddress ? 0.7 : 1,
                            }}>
                                {savingAddress ? '保存中...' : '保存する'}
                            </button>
                        </div>
                    </div>
                )}
            </div>

            {fields.map(f => (
                <div key={f.label} style={{ display: 'flex', gap: 12, marginBottom: 6, fontSize: '0.84rem' }}>
                    <span style={{ color: '#6b7280', minWidth: 90, flexShrink: 0 }}>{f.label}</span>
                    <span style={{ color: '#1a1a2e' }}>{f.value}</span>
                </div>
            ))}

            {(c.panoramic_photo || c.site_photo) && (
                <div style={{ marginTop: 10 }}>
                    <div style={{ fontSize: '0.76rem', color: '#6b7280', marginBottom: 6 }}>現場写真</div>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8 }}>
                        {c.panoramic_photo && (
                            <a href={`${storageBaseUrl}/${c.panoramic_photo}`} target="_blank" rel="noreferrer">
                                <img src={`${storageBaseUrl}/${c.panoramic_photo}`} alt="全景写真" style={{ width: 100, height: 75, objectFit: 'cover', borderRadius: 6 }} />
                            </a>
                        )}
                        {c.site_photo && (
                            <a href={`${storageBaseUrl}/${c.site_photo}`} target="_blank" rel="noreferrer">
                                <img src={`${storageBaseUrl}/${c.site_photo}`} alt="工事箇所の写真" style={{ width: 100, height: 75, objectFit: 'cover', borderRadius: 6 }} />
                            </a>
                        )}
                    </div>
                </div>
            )}

            {c.drawing_file && (
                <div style={{ marginTop: 10 }}>
                    <a
                        href={`${storageBaseUrl}/${c.drawing_file}`}
                        target="_blank" rel="noreferrer"
                        style={{ display: 'inline-flex', alignItems: 'center', gap: 6, padding: '8px 12px', background: '#f5f6f8', borderRadius: 6, textDecoration: 'none', color: '#1a1a2e', fontSize: '0.82rem', fontWeight: 500 }}
                    >
                        図面を開く
                    </a>
                </div>
            )}
        </div>
    );
};

const CustomerAccountPage = () => {
    const customerId = parseInt(localStorage.getItem('customer_id') || '0', 10);

    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(false);
    const [createdAt, setCreatedAt] = useState(null);
    const [condition, setCondition] = useState(null);

    const [lastName, setLastName] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastNameKana, setLastNameKana] = useState('');
    const [firstNameKana, setFirstNameKana] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [postalCode, setPostalCode] = useState('');
    const [prefecture, setPrefecture] = useState('');
    const [city, setCity] = useState('');
    const [address, setAddress] = useState('');
    const [building, setBuilding] = useState('');

    useEffect(() => {
        if (!customerId) { setError('顧客情報が取得できません。ログインし直してください。'); setLoading(false); return; }
        Promise.all([
            api.get(`customers/${customerId}`),
            api.get(`projects/by_customer/${customerId}`),
        ])
            .then(([customerRes, projectsRes]) => {
                const c = customerRes.data;
                setLastName(c.last_name || '');
                setFirstName(c.first_name || '');
                setLastNameKana(c.last_name_kana || '');
                setFirstNameKana(c.first_name_kana || '');
                setEmail(c.email || '');
                setPhone(c.phone || '');
                setPostalCode(c.postal_code || '');
                setPrefecture(c.prefecture || '');
                setCity(c.city || '');
                setAddress(c.address || '');
                setBuilding(c.building || '');
                setCreatedAt(c.created_at);
                // 顧客が入力する工事情報は実質1つ（複数業者への同時応募は同じ内容が案件ごとに複製される）。
                // どの案件が最近動いたか（project.updated_at）ではなく、工事情報自体がいつ入力されたか
                // （condition.created_at）を基準に最新のものを代表として表示する。2件目以降の別工事という概念は未実装。
                const conditions = projectsRes.data.map(p => p.condition).filter(Boolean);
                const latestCondition = conditions.sort((a, b) => new Date(b.created_at) - new Date(a.created_at))[0] || null;
                setCondition(latestCondition);
            })
            .catch(() => setError('アカウント情報の取得に失敗しました。'))
            .finally(() => setLoading(false));
    }, [customerId]);

    const fillAddressFromPostal = async () => {
        const clean = postalCode.replace(/-/g, '');
        if (clean.length !== 7) { setError('郵便番号は7桁で入力してください。'); return; }
        try {
            const res = await fetch(`https://zipcloud.ibsnet.co.jp/api/search?zipcode=${clean}`);
            const data = await res.json();
            if (data.results) {
                const r = data.results[0];
                setPrefecture(r.address1); setCity(r.address2 + r.address3); setError(null);
            } else { setError('該当する住所が見つかりませんでした。'); }
        } catch { setError('住所の取得に失敗しました。'); }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!lastName || !firstName || !email || !phone) {
            setError('お名前・メールアドレス・電話番号は必須です。'); return;
        }
        setSaving(true); setError(null); setSuccess(false);
        try {
            await api.put(`customers/${customerId}`, {
                last_name: lastName, first_name: firstName,
                last_name_kana: lastNameKana, first_name_kana: firstNameKana,
                email, phone,
                postal_code: postalCode.replace(/-/g, ''),
                prefecture, city, address,
                building: building || null,
            });
            setSuccess(true);
        } catch (err) {
            setError(err.response?.data?.message || '保存に失敗しました。');
        } finally {
            setSaving(false);
        }
    };

    if (loading) return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh' }}>
            <div style={{ width: 32, height: 32, border: '3px solid #e0e4ea', borderTopColor: '#005c53', borderRadius: '50%', animation: 'spin 0.8s linear infinite' }} />
            <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
        </div>
    );

    return (
        <div style={{ minHeight: '100vh', background: '#f5f6f8' }}>

            {/* ページヘッダー */}
            <div style={{ background: '#141c3d', padding: '32px 0' }}>
                <div style={{ maxWidth: 640, margin: '0 auto', padding: '0 16px' }}>
                    <h1 style={{ fontSize: '1.5rem', fontWeight: 700, color: '#fff', margin: '0 0 4px' }}>アカウント情報</h1>
                    <p style={{ fontSize: '0.83rem', color: 'rgba(255,255,255,0.55)', margin: 0 }}>
                        ご登録内容の確認・変更ができます
                    </p>
                </div>
            </div>

            <div style={{ maxWidth: 640, margin: '0 auto', padding: '28px 16px' }}>
                <form onSubmit={handleSubmit} style={{ background: '#fff', borderRadius: 10, padding: '24px 20px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)', display: 'flex', flexDirection: 'column', gap: 20 }}>

                    {/* 名前 */}
                    <div>
                        <div style={{ fontWeight: 700, color: '#1a1a2e', marginBottom: 10, fontSize: '0.95rem' }}>お名前</div>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 8 }}>
                            <div>
                                <label style={labelStyle}>姓</label>
                                <input value={lastName} onChange={e => setLastName(e.target.value)} style={textInputStyle} />
                            </div>
                            <div>
                                <label style={labelStyle}>名</label>
                                <input value={firstName} onChange={e => setFirstName(e.target.value)} style={textInputStyle} />
                            </div>
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                            <div>
                                <label style={labelStyle}>セイ（カナ）</label>
                                <input value={lastNameKana} onChange={e => setLastNameKana(e.target.value)} style={textInputStyle} />
                            </div>
                            <div>
                                <label style={labelStyle}>メイ（カナ）</label>
                                <input value={firstNameKana} onChange={e => setFirstNameKana(e.target.value)} style={textInputStyle} />
                            </div>
                        </div>
                    </div>

                    {/* 連絡先 */}
                    <div>
                        <div style={{ fontWeight: 700, color: '#1a1a2e', marginBottom: 10, fontSize: '0.95rem' }}>連絡先</div>
                        <div style={{ marginBottom: 8 }}>
                            <label style={labelStyle}>メールアドレス</label>
                            <input type="email" value={email} onChange={e => setEmail(e.target.value)} style={textInputStyle} />
                            <p style={{ fontSize: '0.74rem', color: '#9ca3af', margin: '4px 0 0' }}>※ ログイン時の認証コード送信先です</p>
                        </div>
                        <div>
                            <label style={labelStyle}>電話番号</label>
                            <input value={phone} onChange={e => setPhone(e.target.value)} style={textInputStyle} />
                        </div>
                    </div>

                    {/* 住所 */}
                    <div>
                        <div style={{ fontWeight: 700, color: '#1a1a2e', marginBottom: 10, fontSize: '0.95rem' }}>現住所</div>
                        <div style={{ display: 'flex', gap: 8, alignItems: 'flex-end', marginBottom: 8 }}>
                            <div style={{ flex: 1 }}>
                                <label style={labelStyle}>郵便番号</label>
                                <input value={postalCode} onChange={e => setPostalCode(e.target.value)} placeholder="1234567（ハイフンなし）" maxLength={8} style={textInputStyle} />
                            </div>
                            <button type="button" onClick={fillAddressFromPostal} style={{
                                padding: '11px 14px', background: '#141c3d', color: '#fff',
                                border: 'none', borderRadius: 6, fontSize: '0.82rem', fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap',
                            }}>
                                住所自動入力
                            </button>
                        </div>
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 8 }}>
                            <div>
                                <label style={labelStyle}>都道府県</label>
                                <select value={prefecture} onChange={e => setPrefecture(e.target.value)} style={textInputStyle}>
                                    <option value=""></option>
                                    {PREFECTURES.map(p => <option key={p}>{p}</option>)}
                                </select>
                            </div>
                            <div>
                                <label style={labelStyle}>市区町村</label>
                                <input value={city} onChange={e => setCity(e.target.value)} style={textInputStyle} />
                            </div>
                        </div>
                        <div style={{ marginBottom: 8 }}>
                            <label style={labelStyle}>番地</label>
                            <input value={address} onChange={e => setAddress(e.target.value)} style={textInputStyle} />
                        </div>
                        <div>
                            <label style={labelStyle}>建物名</label>
                            <input value={building} onChange={e => setBuilding(e.target.value)} style={textInputStyle} />
                        </div>
                    </div>

                    <p style={{ fontSize: '0.78rem', color: '#9ca3af', margin: 0 }}>登録日: {fmtDate(createdAt)}</p>

                    {error && <p style={{ color: '#e53935', fontSize: '0.85rem', margin: 0 }}>{error}</p>}
                    {success && <p style={{ color: '#005c53', fontSize: '0.85rem', margin: 0 }}>保存しました。</p>}

                    <button type="submit" disabled={saving} style={{
                        width: '100%', padding: '14px',
                        background: '#141c3d', color: '#fff',
                        border: 'none', borderRadius: 6,
                        fontWeight: 600, fontSize: '1rem', cursor: saving ? 'default' : 'pointer',
                        opacity: saving ? 0.7 : 1,
                    }}>
                        {saving ? '保存中...' : '保存する'}
                    </button>
                </form>

                {/* 工事情報 */}
                {condition && (
                    <div style={{ background: '#fff', borderRadius: 10, padding: '24px 20px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)', marginTop: 20 }}>
                        <div style={{ fontWeight: 700, color: '#1a1a2e', marginBottom: 4, fontSize: '0.95rem' }}>工事情報</div>
                        <p style={{ fontSize: '0.78rem', color: '#9ca3af', margin: '0 0 16px' }}>
                            依頼時に入力した工事の詳細です
                        </p>
                        <ConditionCard condition={condition} onSaved={setCondition} />
                    </div>
                )}
            </div>
        </div>
    );
};

export default CustomerAccountPage;
